import React, { useState, useEffect } from 'react';
import format_BusQueryDate from './../Common/utils/QueryDateFormat';
import dateformat from 'dateformat';
import getDateObj from "./utils/GetDateObj";
import PropTypes from 'prop-types';
import { isMobileView } from './utils';
import Calendar from '../../components/Calendar';
import {Header} from "@growth/dweb-header";
import { Helmet } from 'react-helmet';
const SeoContainerHeader = ({ src = "", dest = "", src_id = "", dest_id = "", date = "", onUpdateSearch, showHeaderOnly = false, showCalendar = false }) => {

    const [headerStyle, setHeaderStyle] = useState({});
    const [isCalendarOpen, toggleCalendar] = useState(showCalendar);

    const dateObj = (() => {
        if (date) {
            return getDateObj(format_BusQueryDate(date));
        } else {
            return getDateObj();
        };
    })();

    const calendarViewDate = dateformat(dateObj, 'mmm dd, yyyy')

    useEffect(() => {
        const onScroll = () => {
            if (window.pageYOffset > 50) {
                setHeaderStyle({ "position": "fixed" });
            } else {
                setHeaderStyle({});
            }
        }

        if (!isMobileView()) {
            // clean up code
            window.removeEventListener('scroll', onScroll);
            window.addEventListener('scroll', onScroll, { passive: true });
        }

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <>
            {/* <header className="seoHeader">
                <a href="https://www.goibibo.com/">
                    <span className="headerSprite logo"></span>
                </a>
                <ul className="headerNav">
                    <li>
                        <a href="https://www.goibibo.com/flights/" className="nav-link"><span
                            className="headerSprite navIconFlights"></span>Flights</a>
                    </li>
                    <li>
                        <a href="https://www.goibibo.com/hotels/" className="nav-link"><span
                            className="headerSprite navIconHotels"></span>Hotels</a>
                    </li>
                    <li>
                        <a href="https://www.goibibo.com/trains/" className="nav-link"><span
                            className="headerSprite navIconTrains"></span>Trains</a>
                    </li>
                    <li>
                        <a href="https://www.goibibo.com/cars/" className="nav-link"><span
                            className="headerSprite navIconCabs"></span>Cabs</a>
                    </li>
                    <li className="active">
                        <a href="https://www.goibibo.com/bus/" className="nav-link active"><span
                            className="headerSprite navIconBus"></span>Bus</a>
                    </li>
                </ul>
            </header> */}
            <Helmet
                link={[
                    {
                        href: 'https://goibibo.ibcdn.com/styleguide/css/combinedStyles.css',
                        rel: 'stylesheet',
                        type: 'text/css',
                        media: 'all',
                    },
                    {
                        href: 'https://jsak.goibibo.com/pwa_v3/happy-header/8.0.0/ssr/header.css',
                        rel: 'stylesheet',
                        type: 'text/css',
                        media: 'all',
                    },
                ]}
            />
            <Header
                lobName="bus"
                onLoginSuccess={() => {
                    // fetchUserDetails();
                    //window.location.reload();
                    console.log('login successfull');
                }}
                onLogoutSuccess={() => {
                    // fetchUserDetails();
                    //window.location.reload()
                    console.log('logout successfull');
                }}
                sticky={true}
            />

            {!showHeaderOnly ? <div className="seoSearchWidget desktopOnly" style={headerStyle ? headerStyle : ""}>
                <div className="innerSection">
                    <div className="SearchWidgetSection">
                        <div className="searchSection">
                            <div className="searchSectionInner">
                                <label htmlFor="searchWidgetFrom" className="searchWidgetLabel">FROM</label>
                                <div className="relative" onClick={() => {
                                    onUpdateSearch({
                                        src_name: src,
                                        dest_name: dest,
                                        src_id: src_id,
                                        dest_id: dest_id,
                                        selectedDate: date,
                                        src_autosuggest: true
                                    }, 'busUpdateSearch')
                                }}>
                                    <input id="searchWidgetFrom" type="text" placeholder="Enter Source"
                                        className="searchWidgetFrom" value={src} />
                                    <span className="editIconSection"><span
                                        className="headerSprite editIcon"></span><span>Edit</span></span>
                                </div>
                            </div>
                            <div className="swapIcon" onClick={() => {
                                onUpdateSearch({
                                    src_name: dest,
                                    dest_name: src,
                                    src_id: dest_id,
                                    dest_id: src_id,
                                    selectedDate: date
                                }, 'busUpdateSearch')
                            }}>
                                <svg width="35px" height="35px" fill="white" className="">
                                    <path
                                        d="M16 0c8.833.01 15.99 7.167 16 16 0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-4.101 16.125a1.335 1.335 0 00-1.419.183l-4 3.333a1.334 1.334 0 000 2.05l4 3.333A1.334 1.334 0 0012.667 24v-1.667c0-.184.149-.333.333-.333h5a1.333 1.333 0 000-2.666h-5a.333.333 0 01-.333-.333v-1.667c0-.518-.299-.989-.768-1.208zM20.667 16c.312 0 .614-.11.853-.309l4-3.333a1.334 1.334 0 000-2.05l-4-3.333A1.335 1.335 0 0019.334 8v1.667a.333.333 0 01-.333.333h-5a1.333 1.333 0 000 2.666h5c.184 0 .333.149.333.333v1.667c0 .736.597 1.333 1.333 1.333z"></path>
                                </svg>
                            </div>
                            <div className="searchSectionInner">
                                <label htmlFor="searchWidgetTo" className="searchWidgetLabel">TO</label>
                                <div className="relative" onClick={() => {
                                    onUpdateSearch({
                                        src_name: src,
                                        dest_name: dest,
                                        src_id: src_id,
                                        dest_id: dest_id,
                                        selectedDate: date,
                                        dest_autosuggest: true
                                    }, 'busUpdateSearch')
                                }}>
                                    <input id="searchWidgetTo" type="text" placeholder="Enter Destination"
                                        className="searchWidgetFrom" value={dest} />
                                    <span className="editIconSection"><span
                                        className="headerSprite editIcon"></span><span>Edit</span></span>
                                </div>
                            </div>
                        </div>
                        <div className="dateSection">
                            <label htmlFor="searchWidgetDeparture" className="searchWidgetLabel">DEPARTURE DATE</label>
                            <input id="searchWidgetDeparture" type="text" value={calendarViewDate}
                                className="searchWidgetDeparture" onClick={() => {
                                    if(!showCalendar){
                                        onUpdateSearch({
                                            src_name: src,
                                            dest_name: dest,
                                            src_id: src_id,
                                            dest_id: dest_id,
                                            selectedDate: date,
                                            calendar_select: true
                                        }, 'busUpdateSearch');
                                    }else{
                                        toggleCalendar(prev=>!prev);
                                    }
                                }} />
                            <Calendar 
                                dojObj={dateObj} 
                                isCalendarOpen={isCalendarOpen} 
                                toggleCalendar={(value)=>{
                                      toggleCalendar(value);
                                }}
                                onUpdateSearch={({ date }) => {
                                onUpdateSearch({
                                    src_name: src,
                                    dest_name: dest,
                                    src_id: src_id,
                                    dest_id: dest_id,
                                    selectedDate: date,
                                    calendar_select: true
                                });
                                toggleCalendar(prev=>!prev);
                            }} />
                        </div>
                        <div className="searchBtnWrapper" onClick={() => {
                            onUpdateSearch({
                                src_name: src,
                                dest_name: dest,
                                src_id: src_id,
                                dest_id: dest_id,
                                selectedDate: date
                            }, 'busUpdateSearch')
                        }}>
                            <button className="whiteBtn">UPDATE SEARCH</button>
                        </div>
                    </div>
                </div>
            </div> : <></>}
        </>
    )
}


SeoContainerHeader.propTypes = {
    src: PropTypes.string,
    dest: PropTypes.string,
    src_id: PropTypes.string,
    dest_id: PropTypes.string,
    date: PropTypes.any,
    onUpdateSearch: PropTypes.func,
};

SeoContainerHeader.defaultProps = {
    src: "",
    src_id: "",
    dest: "",
    dest_id: "",
};

export default SeoContainerHeader;
